import { DataView } from 'primereact/dataview';
import { SelectButton } from 'primereact/selectbutton';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import { CONSTANT } from '../../../../utils/constants';
import EventDetail from './EventDetail';
import EventItem from './EventItem';
import EventManager from './EventManager';
import styles from "../../../../components/Display/Wrapper.module.scss";

function EventPage({ isActive }) {
  const { accountContext } = useAccountContext();
  const { setActiveView, navigationContext } = useNavigationContext();
  const [eventList, setEventList] = useState([]);
  const [eventDetail, setEventDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [propertyList, setPropertyList] = useState([]);
  const [showpastEventList, setShowPastEventList] = useState(false);
  const [layout, setLayout] = useState('grid');

  const fetchEventList = async () => {
    await privateFetch('GET', 'maisonmousse', `/cu/${accountContext.id}/event/`).then((res) => {
      setEventList(res);
    });
  };

  const fetchPropertyList = async () => {
    await privateFetch(
      'GET',
      'resources',
      `/cu/${accountContext.id}/property/?types=mm_event`
    ).then((res) => {
      if (res) setPropertyList(res);
    });
  };

  useEffect(() => {
    fetchEventList();
    fetchPropertyList();
  }, [navigationContext]);

  const fetchEventDetail = async () => {
    await privateFetch(
      'GET',
      'maisonmousse',
      `/cu/${accountContext.id}/event/${navigationContext.activeEventId}/`
    ).then((res) => {
      if (res) setEventDetail(res);
    });
  };

  const handleClickEvent = (event) => {
    setActiveView("mmevent", event, "activeEventId");
  };

  useEffect(() => {
    if (navigationContext.activeEventId) {
      fetchEventDetail();
    } else setEventDetail(undefined);
  }, [navigationContext]);

  const goBackEventAction = {
    onClick: handleClickEvent,
    label: 'Retour à la liste'
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const newEventAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un évènement',
    icon: 'pi-plus'
  };

  const createEvent = async (eventForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'maisonmousse',
      `/cu/${accountContext.id}/event/`,
      "L'évènement a bien été ajouté",
      JSON.stringify(eventForm)
    ).then(() => {
      fetchEventList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const updateEvent = async (eventForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'maisonmousse',
      `/cu/${accountContext.id}/event/${eventDetail.id}/`,
      "L'évènement a bien été modifié",
      JSON.stringify(eventForm)
    ).then(() => {
      fetchEventList();
      setPanelIsOpen(false);
      fetchEventDetail(eventDetail.id);
      setLoading(false);
    });
  };

  const deleteAttendee = async (attendeeForm) => {
    await privateFetch(
      'DELETE',
      'maisonmousse',
      `/cu/${accountContext.id}/event/${eventDetail.id}/attendee/${attendeeForm.id}`,
      "Le participant a bien été supprimé"
    ).then(() => {
      fetchEventList();
      setEventDetail(undefined);
    });
  };

  const deleteEvent = async (event) => {
    await privateFetch(
      'DELETE',
      'maisonmousse',
      `/cu/${accountContext.id}/event/${event.id}/`,
      "L'évènement a bien été supprimé"
    ).then(() => {
      fetchEventList();
      setEventDetail(undefined);
    });
  };

  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout == "grid" ? "pi-list" : 'pi-th-large'
  };



  const eventFilters = (
    <div className={styles.filterList}>
      <SelectButton
        value={showpastEventList}
        onChange={(e) => setShowPastEventList(e.value)}
        options={CONSTANT.maisonmousse.selectButtonOptions}
        className={styles.switchButton}
        allowEmpty={false}
      />
    </div>

  );


  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Evenements"
        labelAction={handleClickEvent}
        actions={eventDetail ? [goBackEventAction] : [changeLayoutAction, newEventAction]}
        detail={eventDetail}>
        {!eventDetail ? (
          <>{eventFilters}
            <div className={styles.pageContentContainer}>
              <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
                {showpastEventList ? eventList.past_events?.map((event, index) => (
                  <EventItem
                    layout={layout}
                    key={index}
                    event={event}
                    handleClickEvent={() => handleClickEvent(event)} />
                ))
                  : eventList.future_events?.map((event, index) => (
                    <EventItem
                      layout={layout}
                      key={index}
                      event={event}
                      handleClickEvent={() => handleClickEvent(event)} />
                  ))
                }

              </div>
            </div>
          </>
        ) : (
          <EventDetail
            event={eventDetail}
            handleUpdateEvent={handleOpenManager}
            handleDelete={deleteEvent}
            handleDeleteAttendee={deleteAttendee}
          />
        )
        }
      </PageWrapper >
      <EventManager
        isOpen={panelIsOpen}
        onClose={setPanelIsOpen}
        event={eventDetail}
        onCreate={createEvent}
        onUpdate={updateEvent}
        loading={loading}
        propertyList={propertyList}
      />
    </div >
  );
}

export default EventPage;
